import React, {Component} from 'react';
import {Row, Col, ControlLabel, Form, FormGroup, ButtonToolbar, FormControl, Checkbox} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import Validator from "../../../../utilities/Validator";

export default class DostepPasswordForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pas:'',
            uzytLogin:'',
            error: false
        };
        this.onChangePass = this.onChangePass.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.user)) {
            this.setState({
                uzytLogin: this.props.user.login
            })
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.user)) {
            this.setState({
                uzytLogin: nextprops.user.login
            })
        }
    }
    onChangePass(e) {
        this.setState({pas: e.target.value})
    }

    onClickZapisz() {

        this.setState({error: false})
        if(this.state.pas.length>=8 && this.state.pas.length<=20){
            if(Validator.czyZawieraDuzaLitere(this.state.pas) && Validator.czyZawieraCyfreLubZnakSpecjalny(this.state.pas)){

                let data = {
                    idUz: this.props.user.idUz,
                    newPassword: this.state.pas
                }
                this.props.handleZmienHaslo(data);
            }else{
                this.setState({error: 'Pole hasło musi zawierać przynajmniej jedną dużą literę i przynajmniej jedną cyfrę lub znak specjalny'})
            }

        }
        else{
            this.setState({error: 'Pole hasło musi zawierać 8-20 znaków'})
        }

    }

    render() {
        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>Zmiana hasła</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={12}>
                                <Row>
                                    <Col xs={12} lg={2}>
                                        <ControlLabel>
                                            Użytkownik:
                                        </ControlLabel>
                                        <div>
                                            {this.state.uzytLogin}
                                        </div>
                                    </Col>
                                    <Col xs={12} lg={3}>
                                        <ControlLabel>
                                            Nowe hasło: <span style={{color: 'red'}}>*</span>
                                        </ControlLabel>
                                        <FormControl type={'password'} onChange={this.onChangePass} id={'inputHaslo'}/>
                                    </Col>
                                    <Col xs={12} lg={4}>
                                        <div className={'add-label-margin'}></div>
                                            <ButtonToolbar>
                                                <TopButtonCancel onClick={() => {
                                                    this.props.handleClickAnuluj()
                                                }}/>
                                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz nowe hasło'}/>
                                            </ButtonToolbar>
                                    </Col>
                                </Row>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <div id={'zmianaHaslaHelp'}>
                                <div>
                                    <label>Ilość znaków w haśle zawiera się w
                                        8-20? </label> {Boolean(this.state.pas.length >= 8 && this.state.pas.length <= 20) ?
                                    <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                </div>
                                <div>
                                    <label>Czy hasło zawiera dużą literę? </label> {Boolean(Validator.czyZawieraDuzaLitere(this.state.pas)) ?
                                    <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                </div>
                                <div>
                                    <label>Czy hasło zawiera liczbę lub
                                        znak? </label> {Boolean(Validator.czyZawieraCyfreLubZnakSpecjalny(this.state.pas)) ?
                                    <i className="fa fa-check-circle"></i> : <i className="fa fa-times-circle"></i>}
                                </div>
                            </div>

                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <TopIf isTrue={Boolean(this.state.error)}>
                                <Col xs={12}>
                                    <TopAlertUwaga text={this.state.error}/>
                                </Col>
                            </TopIf>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/dostep/components/DostepPasswordForm.js